/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespPriceNegotiationToast_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespPriceNegotiationToastLoader_item$ref: FragmentReference;
export type PdpRespPriceNegotiationToastLoader_item = {|
  +$fragmentRefs: PdpRespPriceNegotiationToast_item$ref,
  +$refType: PdpRespPriceNegotiationToastLoader_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespPriceNegotiationToastLoader_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespPriceNegotiationToast_item",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e9343e42edaea92c66366e4b50669692';
module.exports = node;
